var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyGalleryUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_19949",
    "data-name": "Gruppe 19949",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 130,
    viewBox: "0 0 114 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25243",
    "data-name": "Rechteck 25243",
    width: 114,
    height: 130,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19948",
    "data-name": "Gruppe 19948",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291225",
    "data-name": "Pfad 291225",
    d: "M36.6,67h0l-8.99-.019A21.206,21.206,0,0,1,6.45,49.335,20.391,20.391,0,0,1,18.556,26.918a2.512,2.512,0,0,0,1.615-1.808,13.981,13.981,0,0,1,18.524-9.585c.579.206.67.163,1.054-.518A26.117,26.117,0,0,1,58.075,1.463,26.919,26.919,0,0,1,89.944,27.111c.019.822.1.908.977,1.023a18.582,18.582,0,0,1,16.512,14.3A19.641,19.641,0,0,1,93.271,66.307c-.49.126-.985.232-1.481.319a26.122,26.122,0,0,1-4.077.349L80.006,67h0a.746.746,0,0,1,0-1.491l7.7-.025a24.668,24.668,0,0,0,3.834-.327c.451-.08.907-.178,1.359-.294a18.131,18.131,0,0,0,13.085-22.07A17.113,17.113,0,0,0,90.76,29.615c-1.369-.179-2.268-.664-2.309-2.466a25.437,25.437,0,0,0-30.1-24.221,24.642,24.642,0,0,0-17.291,12.79,2.1,2.1,0,0,1-2.885,1.2,12.679,12.679,0,0,0-1.376-.437,12.489,12.489,0,0,0-15.177,8.976A3.971,3.971,0,0,1,19.1,28.305,18.89,18.89,0,0,0,7.92,49.077,19.734,19.734,0,0,0,27.593,65.49l9,.019A.745.745,0,1,1,36.6,67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291226",
    "data-name": "Pfad 291226",
    d: "M58.558,75a.747.747,0,0,1-.75-.744V44.708a.75.75,0,0,1,1.5,0V74.256a.747.747,0,0,1-.75.744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291227",
    "data-name": "Pfad 291227",
    d: "M71.395,58.256a.693.693,0,0,1-.5-.221L58.61,45.077,46.33,58.035a.688.688,0,0,1-1.011,0,.785.785,0,0,1,0-1.067L58.1,43.477a.688.688,0,0,1,1.011,0L71.9,56.968a.783.783,0,0,1,0,1.067.693.693,0,0,1-.505.221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291228",
    "data-name": "Pfad 291228",
    d: "M56.48,102.37a3.522,3.522,0,1,1,.893-.116,3.527,3.527,0,0,1-.893.116m0-5.542a2.021,2.021,0,1,0,1.95,1.508,2.024,2.024,0,0,0-1.95-1.508"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291229",
    "data-name": "Pfad 291229",
    d: "M41.848,116.592a.75.75,0,0,1-.633-1.151l3.72-5.883a3.453,3.453,0,0,1,4.533-1.191l4.217,2.267a1.944,1.944,0,0,0,2.394-.453,3.4,3.4,0,0,1,4.076-.889l3.854,1.8a.75.75,0,1,1-.635,1.359l-3.854-1.8a1.9,1.9,0,0,0-2.288.49,3.46,3.46,0,0,1-4.257.814l-4.217-2.266a1.943,1.943,0,0,0-2.555.671l-3.721,5.883a.748.748,0,0,1-.634.349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291230",
    "data-name": "Pfad 291230",
    d: "M40.571,125.267a2.6,2.6,0,0,1-2.533-2.049L32.576,97.947a2.6,2.6,0,0,1,1.989-3.087l27.076-5.852A2.6,2.6,0,0,1,64.728,91l5.462,25.271a2.6,2.6,0,0,1-1.99,3.087l-27.075,5.852a2.61,2.61,0,0,1-.554.06M62.192,90.449a1.1,1.1,0,0,0-.234.025L34.882,96.326a1.1,1.1,0,0,0-.84,1.3L39.5,122.9a1.1,1.1,0,0,0,1.3.84l27.075-5.852a1.1,1.1,0,0,0,.841-1.3L63.262,91.314a1.1,1.1,0,0,0-1.07-.865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291231",
    "data-name": "Pfad 291231",
    d: "M69.478,116.046a.75.75,0,0,1,0-1.5,1.1,1.1,0,0,0,1.1-1.1V87.6a1.1,1.1,0,0,0-1.1-1.1h-27.7a1.1,1.1,0,0,0-1,.654c-.053.635-.093,4.444-.093,4.918a.75.75,0,0,1-1.5,0c0-.049.007-4.959.16-5.373A2.608,2.608,0,0,1,41.777,85h27.7a2.6,2.6,0,0,1,2.6,2.6v25.854a2.6,2.6,0,0,1-2.6,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291232",
    "data-name": "Pfad 291232",
    d: "M60.314,86.37a.743.743,0,0,1-.256-.045l-6.925-2.512a1,1,0,0,0-1.043.218c-.06.132-.231.54-.705,1.782a.75.75,0,0,1-1.4-.536,9.26,9.26,0,0,1,.917-2.168,2.507,2.507,0,0,1,2.745-.706l6.925,2.512a.75.75,0,0,1-.256,1.455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_291233",
    "data-name": "Pfad 291233",
    d: "M70.682,122.482a2.633,2.633,0,0,1-.9-.16L64.867,120.4a.75.75,0,1,1,.547-1.4l4.894,1.919a1.153,1.153,0,0,0,1.465-.7l9.109-25.109a1.16,1.16,0,0,0-.694-1.483l-9-3.265a.75.75,0,0,1,.512-1.41l9,3.265a2.657,2.657,0,0,1,1.592,3.4L73.183,120.73a2.661,2.661,0,0,1-2.5,1.752"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGalleryUp);
export default __webpack_public_path__ + "static/media/empty_gallery_up.62a613a05b6aeca661a62255d6cc759b.svg";
export { ForwardRef as ReactComponent };